import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { Box } from '@mui/material';
import { SequencingWizardContext } from '../../SequencingWizardContext';
import LocationCheckboxList from '../../components/LocationCheckboxList.connector';
import Buttons from '../../components/Buttons';
import SummaryDrawer from '../../components/SummaryDrawer';

const RemoveStep3 = props => {
  const { next, prev } = props;
  const {
    data: { locations = [] },
    setData,
  } = useContext(SequencingWizardContext);

  const continueDisabled = R.isEmpty(locations);

  const handleChange = R.o(setData, R.assoc('locations'));

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 203px
          // prevents progress bar from looking off
          height: 'calc(100% - 203px)',
          mb: '46px',
          overflowY: 'auto',
        }}
      >
        <Box flexGrow={1}>
          <LocationCheckboxList
            onChange={handleChange}
            title="Select one or more locations where products are available"
          />
        </Box>
        <SummaryDrawer displayProducts inventoryOwnerSubtitle="Selected Inventory Owner" />
      </Box>
      <Buttons
        disabled={continueDisabled}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        rightLabel="Continue"
      />
    </>
  );
};

RemoveStep3.propTypes = {
  next: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
};

export default RemoveStep3;
